import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        orange: {
            color: theme.palette.common.orange,
        },
        red: {
            color: theme.palette.common.red,
        },
        grey: {
            color: theme.palette.secondary[900],
        },
        green: {
            color: theme.palette.common.green,
        },
    }
})

export default useStyles
